/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { BaseRequestConfig } from '../../framework/BaseRequestConfig';
import { VideoCriteriaJson } from '../json/JsonAll';
import { VideoJson } from '../json/JsonAll';
import { VideoListJson } from '../json/JsonAll';
import { SelectItemJson } from '../json/JsonAll';
import { DeleteJson } from '../json/JsonAll';
import { Net } from '../../common/extends_fw/Net';

export class VideoApi {
    /**
     * Base Pathの設定。デフォルトは「/」
     */
    protected basePath: string = '/';

    /**
     * コンストラクタ
     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
     * @param { string } basePath ベースパスを設定する
     */
    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService, protected $httpParamSerializer: ng.IHttpParamSerializer, basePath: string, protected $net: Net, protected Upload: any) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    /**
     * 動画の情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public list(criteria: VideoCriteriaJson,
                isDbl: boolean = true): ng.IHttpPromise<VideoListJson[]> {
        return this.$net.get('/videos/list', criteria);
    }

    /**
     * 動画の情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public getRecord(id: number,
                isDbl: boolean = true): ng.IHttpPromise<VideoJson> {
        return this.$net.get('/videos/' + id + '/edit', null);
    }

    /**
     * 動画の情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public update(record: VideoJson,
                video: any, thumbnail: any,
                isDbl: boolean = true): ng.IHttpPromise<VideoJson> {
        let param: any = this.$net.createParam(record);
        param.video = video;
        param.thumbnail = thumbnail;
        return this.Upload.upload({
            url: this.basePath + '/videos/update',
            fields: param
        });
    }

    /**
     * 動画の情報を削除する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public delete(ids: number[],
                isDbl: boolean = true): ng.IHttpPromise<DeleteJson> {
        return this.$net.post('/videos/delete', { ids: ids.join(',') });
    }

    /**
     * 動画のURLを取得する。
     * @param url  動画URL
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public url(url: string,
                isDbl: boolean = true): ng.IHttpPromise<VideoUrlJson> {
        return this.$net.get(url);
    }

    /**
     * 動画の情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public create(record: VideoJson,
                video: any, thumbnail: any,
                isDbl: boolean = true): ng.IHttpPromise<VideoJson> {
        let param: any = this.$net.createParam(record);
        param.video = video;
        param.thumbnail = thumbnail;
        return this.Upload.upload({
            url: this.basePath + '/videos/create',
            fields: param
        });
    }

    /**
     * メインカテゴリリストの情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public getMainCategoryList(
                isDbl: boolean = true): ng.IHttpPromise<SelectItemJson[]> {
        return this.$net.get('/categories/listAll', null);
    }

    /**
     * サブカテゴリの情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public getSubCategoryList(mainId: string,
                isDbl: boolean = true): ng.IHttpPromise<SelectItemJson> {
        return this.$net.get('/categories/' + mainId + '/listAll', null);
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/api/VideoApi.ts
 **/